import { FormattedCity } from "@website/ticket-ui/common/types";

export const createOriginDestinationItemSubtitle = (city: FormattedCity) => {
  const { cityFaName, airports } = city ?? {};

  if (Array.isArray(airports) && airports.length > 1) {
    return "همه فرودگاه ها";
  }
  return `${airports?.[0]?.faName || `فرودگاه ${cityFaName}`} - ${airports?.[0]
    ?.iataCode}`;
};

export const createOriginDestinationInputText = (
  city: FormattedCity | null
) => {
  if (city) {
    const {
      airportName,
      cityFaName,
      airportIataCode,
      airportFaName,
      airports
    } = city ?? {};
    if (airportName) {
      return `${cityFaName}، (${airportIataCode}) ${
        airportFaName || `فرودگاه ${airportName}`
      }`;
    }
    if (
      (Array.isArray(airports) && airports.length > 1) ||
      !Array.isArray(airports)
    ) {
      return cityFaName;
    }
    return `${cityFaName}، (${airports?.[0]?.iataCode}) ${
      airports?.[0]?.faName || `فرودگاه ${airports?.[0]?.name}`
    }`;
  }
  return "";
};

export const createOriginDestinationHistorySubtitle = (city: FormattedCity) => {
  const { airportName, cityFaName, airportIataCode, airports } = city ?? {};

  if (city) {
    if (airportName) {
      return `${cityFaName} - ${airportIataCode}`;
    }
    if (Array.isArray(airports) && airports.length > 1) {
      return cityFaName;
    }
    return `${cityFaName}، (${airports?.[0]?.iataCode}) ${
      airports?.[0]?.faName || `فرودگاه ${airports?.[0]?.name}`
    }`;
  }
};

export const createOriginDestinationHistoryTitle = (city: FormattedCity) => {
  const { airportName, cityFaName, airportFaName, countryFaName } = city ?? {};

  if (airportName) {
    return airportFaName || `فرودگاه ${airportName}`;
  }
  return `${cityFaName}، ${countryFaName}`;
};
